/**
 * Медиа фона главной / входа (лендинг + auth).
 *
 * 1. Положите файлы в репозитории: media/landing-hero/ (см. media/README.md)
 * 2. Перед деплоем: node scripts/sync-media-assets.js (или deploy.bat)
 * 3. Переключение фото / видео: HERO_MEDIA_MODE ниже
 */

/** @type {'images' | 'video'} */
export const HERO_MEDIA_MODE = 'images';

export const SLIDE_KEYS = ['hockey', 'football', 'danceGym', 'swim', 'athletics'];

const FILE_KEY = {
    hockey: 'hockey',
    football: 'football',
    danceGym: 'gymnastics',
    swim: 'swimming',
    athletics: 'athletics',
};

/** Имена файлов без расширения: sport-{hockey|football|...} */
export function sportFileKey(slideKey) {
    return FILE_KEY[slideKey] || slideKey;
}

/**
 * Пути после sync-media-assets.js → frontend/public/
 *
 * images/web/           → /images/sports/              (JPG/WebP, ~1920×1080)
 * images/web-tablet/   → /images/sports/tablet/       (WebP/JPG, ~1280×720)
 * images/web-mobile/    → /images/sports/mobile/       (WebP/JPG, ~720×1280)
 *
 * videos/web/           → /media/landing/videos/web/   (.mp4 H.264, опц. .webm)
 * videos/web-tablet/    → /media/landing/videos/web-tablet/
 * videos/web-mobile/    → /media/landing/videos/web-mobile/
 */
export const HERO_IMAGE_EXT = {
    web: '.jpg',
    webTablet: '.webp',
    webMobile: '.webp',
};

export const HERO_VIDEO_EXT = {
    mp4: '.mp4',
    webm: '.webm',
};

function imageBase(breakpoint) {
    if (breakpoint === 'webTablet') return '/images/sports/tablet';
    if (breakpoint === 'webMobile') return '/images/sports/mobile';
    return '/images/sports';
}

function videoBase(breakpoint) {
    if (breakpoint === 'webTablet') return '/media/landing/videos/web-tablet';
    if (breakpoint === 'webMobile') return '/media/landing/videos/web-mobile';
    return '/media/landing/videos/web';
}

/** @param {'web'|'webTablet'|'webMobile'} breakpoint */
export function getHeroImageUrl(slideKey, breakpoint = 'web') {
    const ext = HERO_IMAGE_EXT[breakpoint] || HERO_IMAGE_EXT.web;
    return `${imageBase(breakpoint)}/sport-${sportFileKey(slideKey)}${ext}`;
}

/** @param {'web'|'webTablet'|'webMobile'} breakpoint */
export function getHeroVideoSources(slideKey, breakpoint = 'web') {
    const base = videoBase(breakpoint);
    const name = `sport-${sportFileKey(slideKey)}`;
    return {
        mp4: `${base}/${name}${HERO_VIDEO_EXT.mp4}`,
        webm: `${base}/${name}${HERO_VIDEO_EXT.webm}`,
        poster: getHeroImageUrl(slideKey, breakpoint),
    };
}

export const HERO_SLIDES = SLIDE_KEYS.map((key) => ({ key }));
